import React from 'react';
import { useQuery } from '@apollo/client';
import { Skeleton, Stack, Table, Text } from '@mantine/core';
import { getFinancialInfoForVendorAtLocation } from '@/api';
import { PopupEventVendorDetailsUpcoming } from '../types';

type PopupUpcomingTopProps = {
  event: PopupEventVendorDetailsUpcoming;
};

export const PopupUpcomingTop: React.FC<PopupUpcomingTopProps> = ({ event }) => {
  const { data, loading } = useQuery(getFinancialInfoForVendorAtLocation, {
    variables: {
      input: { vendorId: event.vendor.id, locationId: event.eventLocation?.location.id ?? '' },
    },
  });

  const topSales = (data?.getFinancialInfoForVendorAtLocation?.sales?.foodTopSales || []).toSorted(
    (a, b) => b.percentGfs - a.percentGfs
  );

  if (loading) {
    return (
      <>
        <Skeleton mt="md" h="md" w="80%" />
        <Skeleton mt="md" h="md" w="100%" />
        <Skeleton mt="md" h="md" w="80%" />
        <Skeleton mt="md" h="md" w="70%" />
      </>
    );
  }

  return (
    <Stack gap="4">
      <Text>Your top items at this location</Text>
      <Stack gap="xs" bdrs="md" bd="1px solid var(--mantine-color-gray-4)">
        {!event.usesFoodaPos ? (
          <Text fw="bold">No data available - Fooda POS not used at this location</Text>
        ) : (
          <Table fz="sm">
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Item</Table.Th>
                <Table.Th ta="center" w="100px">
                  (% GFS)
                </Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {topSales.length ? (
                topSales.map((item) => (
                  <Table.Tr key={item.name}>
                    <Table.Td>{item.name}</Table.Td>
                    <Table.Td ta="center">{(Math.abs(item.percentGfs) * 100).toFixed(0)}%</Table.Td>
                  </Table.Tr>
                ))
              ) : (
                <Table.Tr>
                  <Table.Td colSpan={2} ta="center">
                    <Text fz="sm" fw="bold">
                      This will be your first time visiting this location
                    </Text>
                  </Table.Td>
                </Table.Tr>
              )}
            </Table.Tbody>
          </Table>
        )}
      </Stack>
    </Stack>
  );
};

export default PopupUpcomingTop;
